import { getConfigFor } from './helpers/getConfigFor';

export const hasCmsPreview = getConfigFor.environment<boolean>({
	default: true,
	prd: false,
});
